import { OrderStatus } from "@app/types/orders";
import { OrderStatusTone } from "@app/domain";

/**
 * Derives a semantic tone from the raw backend `OrderStatus` string — there
 * is no such derivation in production today; the legacy `components/Status`
 * color map only ever covered the Ondemand-ish statuses
 * (Pending/Unassigned/Assigned/Started/PickedUp/Done/Arrived/the
 * *Canceled family), defaulting everything else (every richer
 * PickupDelivery stage status — InTransit, OutForDelivery, Delivered, ...)
 * to plain black. Those 8 legacy-covered statuses keep their exact legacy
 * semantics here; the rest are extended sensibly using the same pattern
 * (queued → warning, active → info, success → success, genuine failure →
 * danger, canceled/returned → neutral) so the redesign's richer status pill
 * doesn't go flat/uncolored for order kinds legacy's Status component never
 * got updated for.
 */
export function statusToTone(status: OrderStatus): OrderStatusTone {
  switch (status) {

    // Canceled/returned — legacy: *Canceled family #484848 (neutral gray)
    case "Draft":
    case "CustomerCanceled":
    case "SupportCanceled":
    case "DriverCanceled":
    case "Returned":
      return "neutral";

    case "Pending":
      return "pending";
    
    case "Confirmed":
    case "AtWarehouse":
    case "ReadyForTransit":
    case "InTransit":
    case "Unassigned":
      return "warning";

    case "Assigned":
      return "assigned";

    case "PickupRouted":
    case "DeliveryRouted":
      return "primary";

    case "ReadyForPickup":
    case "PickedUp":
    case "AtPickupServicePoint":
    case "ReadyForDelivery":
    case "OutForDelivery":
    case "AtDeliveryServicePoint":
    case "Started":
    case "Arrived":
      return "info";

    case "Done":
    case "Delivered":
      return "success";

    case "PickupFailed":
    case "NotDelivered":
    case "ForReturn":
    case "Lost":
      return "danger";

    default:
      return "neutral";
  }
}
